import { 
  LayoutDashboard, 
  Ticket,
  User,
} from 'lucide-react';
import type { NavConfig } from './nav.types';

/**
 * Customer portal navigation
 * For users with bookings but no producer role
 * Note: "Bli producent" is in the topbar dropdown, not here
 */
export const customerNav: NavConfig = [
  {
    // No title - cleaner look for customer portal
    items: [
      {
        label: 'Översikt',
        href: '/app/customer',
        icon: LayoutDashboard,
        exact: true,
      },
      {
        label: 'Bokningar & beställningar',
        href: '/app/customer/bookings',
        icon: Ticket,
        badgeKey: 'upcomingBookings',
      },
      {
        label: 'Profil',
        href: '/app/customer/profile',
        icon: User,
      },
    ],
  },
];
